import type { ReportLayoutConfig, SectionBuild } from '../models/layoutConfig.types'

// v3 `configs/AppAnalytics/StoreAnalysis.js` (78 ln). Two `topTabField: 'name'` sections →
// `topTabMode`; each v3 tab paired a machine `name` (segment label) with a display `title`
// (section heading) — `name` stays machine, segment copy moves to `labelKey`, the heading
// to the per-tab `titleKey`. v3 page-tab `isNotTabCard` has no v4 field and drops.

const STORE_ANALYSIS_REPORT_ID = 58

// v3 `configStore` — id keyed by the tab's first partition (every tab carries one).
const storeAnalysisBuild: SectionBuild = ({ tab }) => ({
  id: `58-${tab.tabs?.[0] ?? tab.name}`,
  reportId: STORE_ANALYSIS_REPORT_ID,
  scheduleTabs: tab.tabs ?? [],
})

export const STORE_ANALYSIS: ReportLayoutConfig = [
  {
    name: 'Overview',
    labelKey: 'reports.storeAnalysis.tabs.overview',
    sections: [
      {
        id: '58-crash-download-install',
        reportId: STORE_ANALYSIS_REPORT_ID,
        topTabMode: true,
        build: storeAnalysisBuild,
        tabs: [
          {
            name: 'Crash',
            labelKey: 'reports.storeAnalysis.crashDownloadInstall.crash',
            titleKey: 'reports.storeAnalysis.crashDownloadInstall.crashTitle',
            tabs: ['app_crash_details'],
          },
          {
            name: 'Download',
            labelKey: 'reports.storeAnalysis.crashDownloadInstall.download',
            titleKey: 'reports.storeAnalysis.crashDownloadInstall.downloadTitle',
            tabs: ['app_download_details'],
          },
          {
            name: 'Install/Uninstall',
            labelKey: 'reports.storeAnalysis.crashDownloadInstall.installUninstall',
            titleKey: 'reports.storeAnalysis.crashDownloadInstall.installUninstallTitle',
            tabs: ['app_installation_and_deletion_details'],
          },
        ],
      },
      {
        id: '58-purchase-sessions-engagement',
        reportId: STORE_ANALYSIS_REPORT_ID,
        topTabMode: true,
        build: storeAnalysisBuild,
        tabs: [
          {
            name: 'Purchase',
            labelKey: 'reports.storeAnalysis.purchaseSessionsEngagement.purchase',
            titleKey: 'reports.storeAnalysis.purchaseSessionsEngagement.purchaseTitle',
            tabs: ['app_purchase_details'],
          },
          {
            name: 'Sessions',
            labelKey: 'reports.storeAnalysis.purchaseSessionsEngagement.sessions',
            titleKey: 'reports.storeAnalysis.purchaseSessionsEngagement.sessionsTitle',
            tabs: ['app_sessions_details'],
          },
          {
            name: 'Engagement',
            labelKey: 'reports.storeAnalysis.purchaseSessionsEngagement.engagement',
            titleKey: 'reports.storeAnalysis.purchaseSessionsEngagement.engagementTitle',
            tabs: ['app_discovery_and_engagement_details'],
          },
        ],
      },
    ],
  },
]
